import { render, staticRenderFns } from "./SmsDialog2.vue?vue&type=template&id=64710abd"
import script from "./SmsDialog2.vue?vue&type=script&lang=js"
export * from "./SmsDialog2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports